import classnames from 'classnames'
import React, { useRef } from 'react'
import { SwiperRef } from 'swiper/react'

import IconWithTextfeature, {
  IconWithTextfeatureProps,
} from '@src/quince-components/src/atoms/iconWithTextfeature/IconWithTextfeature'
import Swiper from '@src/quince-components/src/atoms/swiper'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import styles from './featureSection.module.scss'

export interface FeatureSectionProps {
  heading: string
  description?: string
  contents: IconWithTextfeatureProps[]
  className?: string
  layoutType: LAYOUT_TYPES
}

export const FeatureSection = (props: FeatureSectionProps) => {
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  const carouselRef = useRef<SwiperRef | null>(null)

  const featureSectionClass = props.layoutType === LAYOUT_TYPES.CAROUSEL && isMobile ? '' : styles.featureSectionPadded
  const wrapClassnames = classnames(styles.featureSectiontwoWrap, featureSectionClass, props.className, {
    [styles.carouselWrap!]: props.layoutType === LAYOUT_TYPES.CAROUSEL,
  })

  return (
    <div className={props?.className}>
      {props?.heading?.length > 0 && <div className={styles.headerText}>{props.heading}</div>}
      <div className={wrapClassnames}>
        {isMobile && props.layoutType === LAYOUT_TYPES.CAROUSEL ? (
          <Swiper
            id="tex-block-with-icon-carousel"
            showDots={true}
            showNavigator={false}
            numberOfVisibleSlides={1}
            variableWidth={isMobile}
            freeMode={false}
            ref={carouselRef}
            initialSlide={0}
            virtualOptions={{ enabled: true }}
            className={styles.cardList}
            slideClassName={styles.cardList__slide}
          >
            {props.contents.map((item: IconWithTextfeatureProps, index: number) => {
              return (
                <div className={styles.sliderWrapper} key={index}>
                  <IconWithTextfeature
                    {...item}
                    align="center"
                    className={classnames(styles.infoItem, styles.Icon, styles[`infoItem__item_${index}`])}
                    imageWrapperClassName={classnames(
                      styles.infoItem__imageWrapperClassName,
                      styles[`infoItem__imageWrapperClassName__${index + 1}`],
                    )}
                  />
                </div>
              )
            })}
          </Swiper>
        ) : (
          props.contents.map((item: IconWithTextfeatureProps, index: number) => {
            return (
              <IconWithTextfeature
                {...item}
                align="center"
                className={classnames(styles.infoItem, styles.Icon, styles[`infoItem__item_${index}`])}
                key={index}
                imageWrapperClassName={classnames(
                  styles.infoItem__imageWrapperClassName,
                  styles[`infoItem__imageWrapperClassName__${index + 1}`],
                )}
              />
            )
          })
        )}
      </div>
    </div>
  )
}
FeatureSection.defaultProps = {
  className: '',
}
export default FeatureSection
